export default __webpack_public_path__ + "d05217b9f8b2182987693d822a05ae9f.png";